"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardRowComponent = void 0;
var vue_1 = require("vue");
var CardRenderItem_1 = require("../../cards/render/CardRenderItem");
var ICardRenderDescription_1 = require("../../cards/render/ICardRenderDescription");
var CardRenderSymbol_1 = require("../../cards/render/CardRenderSymbol");
var CardRenderer_1 = require("../../cards/render/CardRenderer");
var CardRenderer_2 = require("../../cards/render/CardRenderer");
var CardRenderItemComponent_1 = require("./CardRenderItemComponent");
var CardProductionBoxComponent_1 = require("./CardProductionBoxComponent");
var CardRenderEffectBoxComponent_1 = require("./CardRenderEffectBoxComponent");
var CardRenderCorpBoxComponent_1 = require("./CardRenderCorpBoxComponent");
var CardRenderTileComponent_1 = require("./CardRenderTileComponent");
var CardDescription_1 = require("./CardDescription");
var CardRenderSymbolComponent_1 = require("./CardRenderSymbolComponent");
var CardRenderer_3 = require("../../cards/render/CardRenderer");
exports.CardRowComponent = vue_1.default.component('CardRowComponent', {
    props: {
        componentData: {
            type: Object,
            required: true,
        },
    },
    components: {
        CardRenderSymbolComponent: CardRenderSymbolComponent_1.CardRenderSymbolComponent,
        CardRenderItemComponent: CardRenderItemComponent_1.CardRenderItemComponent,
        CardProductionBoxComponent: CardProductionBoxComponent_1.CardProductionBoxComponent,
        CardRenderEffectBoxComponent: CardRenderEffectBoxComponent_1.CardRenderEffectBoxComponent,
        CardRenderCorpBoxComponent: CardRenderCorpBoxComponent_1.CardRenderCorpBoxComponent,
        CardRenderTileComponent: CardRenderTileComponent_1.CardRenderTileComponent,
        CardDescription: CardDescription_1.CardDescription,
    },
    methods: {
        isItem: function () {
            return this.componentData instanceof CardRenderItem_1.CardRenderItem;
        },
        isSymbol: function () {
            return this.componentData instanceof CardRenderSymbol_1.CardRenderSymbol;
        },
        isProduction: function () {
            return this.componentData instanceof CardRenderer_1.CardRenderProductionBox;
        },
        isEffect: function () {
            return this.componentData instanceof CardRenderer_3.CardRenderEffect;
        },
        isDescription: function () {
            return typeof this.componentData === 'string' || this.componentData instanceof String || ICardRenderDescription_1.isIDescription(this.componentData);
        },
        isTile: function () {
            return this.componentData instanceof CardRenderer_2.CardRenderTile;
        },
        isCorpBox: function () {
            return this.componentData instanceof CardRenderer_3.CardRenderCorpBoxEffect || this.componentData instanceof CardRenderer_3.CardRenderCorpBoxAction;
        },
        corpBoxLabel: function () {
            if (this.componentData instanceof CardRenderer_3.CardRenderCorpBoxEffect) {
                return 'effect';
            }
            else if (this.componentData instanceof CardRenderer_3.CardRenderCorpBoxAction) {
                return 'action';
            }
            return 'n/a';
        },
    },
    template: " \n        <CardRenderItemComponent v-if=\"isItem()\" :item=\"componentData\"/>\n        <CardRenderSymbolComponent v-else-if=\"isSymbol()\" :item=\"componentData\" />\n        <CardProductionBoxComponent v-else-if=\"isProduction()\" :rows=\"componentData.rows\" />\n        <CardRenderEffectBoxComponent v-else-if=\"isEffect()\" :effectData=\"componentData\" />\n        <CardRenderTileComponent v-else-if=\"isTile()\" :item=\"componentData\" />\n        <CardDescription v-else-if=\"isDescription()\" :item=\"componentData\" />\n        <CardRenderCorpBoxComponent v-else-if=\"isCorpBox()\" :rows=\"componentData.rows\" :label=\"corpBoxLabel()\" />\n        <div v-else>n/a</div>\n    ",
});
//# sourceMappingURL=CardRowComponent.js.map